import React, { useState } from "react";
import { PageLayout } from "../../componentes";
import { Box, Grid, Tab, Tabs } from "@material-ui/core";
import { useThemeBreakpoints } from "../../../api";
import { UsersAdmin } from "./UsersAdmin";

const selectTab = (setSelectedTab) => (event, value) => {
    setSelectedTab(value);
};

export const Admin = () => {
    const { isDownXs } = useThemeBreakpoints();
    const [selectedTab, setSelectedTab] = useState("users");

    return (
        <PageLayout title="Admin" showInBoxCard={false}>
            <Box marginBottom={1}>
                <Tabs
                    variant={isDownXs ? "scrollable" : "standard"}
                    indicatorColor="primary"
                    textColor="primary"
                    scrollButtons="on"
                    value={selectedTab}
                    onChange={selectTab(setSelectedTab)}
                >
                    <Tab
                        label="Usuários"
                        value="users"
                        style={{ fontSize: "0.85rem" }}
                    />
                </Tabs>
            </Box>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <UsersAdmin />
                </Grid>
            </Grid>
        </PageLayout>
    );
};
